import * as React from "react";
import { Box, AppBar, Toolbar, IconButton, Typography } from "@mui/material";
import { useState, useEffect } from "react";
import Links from "./ui/Links";
import LeftDrawerComponent from "./ui/LeftDrawerComponent";

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <Box sx={{ flexGrow: 1, mb: 0 }}>
      <AppBar
        position="fixed"
        sx={{
          backgroundColor: isScrolled ? "#000" : "#000",
          transition: "background-color 0.3s ease",
          boxShadow: isScrolled
            ? "0px 4px 20px rgba(0, 0, 0, 0.3), 0px 2px 10px rgba(0, 0, 0, 0.1)"
            : "none",
          borderBottom: isScrolled
            ? "1px solid gray"
            : "1px solid rgba(255, 255, 255, 0.5)",
        }}
      >
        <Toolbar sx={{ height: "80px", justifyContent: "center" }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              textAlign: "center",
              gap: 1,
              mt: { xs: 3.5, md: 6 },
            }}
          >
            <Typography
              variant="body1"
              noWrap
              component="div"
              sx={{
                color: "white",
                fontWeight: "bold",
                letterSpacing: "1px",
                fontSize: {
                  xs: "1.3rem",
                  md: "1.7rem",
                },
              }}
            >
              Владислав Кронин
            </Typography>
            <Typography
              variant="body2"
              sx={{
                color: "white",
                fontSize: {
                  xs: "0.9rem",
                  md: "1.2rem",
                },
              }}
            >
              Бизнес & Лайф Коуч
            </Typography>
            <IconButton
              size="large"
              edge="start"
              color="inherit"
              aria-label="open drawer"
              sx={{ mr: 2 }}
            ></IconButton>
            <Links />
          </Box>
        </Toolbar>
      </AppBar>

      <LeftDrawerComponent />
    </Box>
  );
};

export default Header;
